import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button, styled } from '@material-ui/core';
import { useResource } from '../../../hooks/resources';
import InnerHeader from '../../../component/InnerHeader';
import Loader from '../../../component/Loader/Loader';
import { useNotification } from '../../../providers/notificationsProvider';
import useToggle from '../../../hooks/useToggle';
import ResourceForm from '../../../component/forms/ResourceForm';

const Wrapper = styled('div')({
  padding: '1.5rem'
});

const ButtonWrapper = styled('div')({
  display: 'flex',
  marginBottom: '1rem'
});

const DetailsWrapper = styled('div')({
  border: '1px solid #ccc',
  borderRadius: '0.4rem',
  maxWidth: '44rem',
  padding: '1rem'
});

const ContentInner = styled('div')({
  '&:last-child': {
    paddingBottom: '0'
  },
  display: 'flex',
  justifyContent: 'flex-start',
  paddingBottom: '1rem'
});

const Heading = styled('div')({
  fontWeight: 'bold',
  minWidth: '7rem',
  textAlign: 'start'
});

const Detail = styled('div')({
  fontSize: '0.875rem',
  textAlign: 'start'
});

const labels = {
  _id: 'ID',
  metadata: 'Metadata',
  monthlyCost: 'Monthly Cost',
  name: 'Name',
  type: 'Type'
};

const ResourceDetails = () => {
  const { state } = useLocation();
  const { open, handleOpen, handleClose } = useToggle();
  const { notify } = useNotification();
  const { data, isLoading, isError } = useResource(state.resourceId, state.projectId);

  if (isError) {
    notify({ message: 'error try again', severity: 'error' });
  }

  const { ...resource } = data?.resource || {};

  return (
    <Wrapper>
      <InnerHeader title="Resource Details" />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <ButtonWrapper>
            <Button color="primary" onClick={handleOpen} variant="contained">
              Edit
            </Button>
          </ButtonWrapper>
          <DetailsWrapper>
            {Object.keys(resource).map((resourceKey, idx) => (
              <ContentInner key={idx}>
                <Heading>{labels[resourceKey]}:</Heading>
                <Detail>{resource[resourceKey]}</Detail>
              </ContentInner>
            ))}
          </DetailsWrapper>
          <ResourceForm
            currentProject={state.projectId}
            handleClose={handleClose}
            open={open}
            resource={data.resource}
          />
        </>
      )}
    </Wrapper>
  );
};

export default ResourceDetails;
